import type { CheckboxGroupProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

export default function CheckboxGroup(props: CheckboxGroupProps) {
  const { inputId, onAdd, onRemove, options, value } = props

  const handleChange =
    (optionValue: number) => (checked: boolean | 'indeterminate') => {
      if (checked === true) {
        onAdd(optionValue)
      } else {
        onRemove(optionValue)
      }
    }

  return (
    <InputFieldset {...props}>
      {options.map(option => (
        <div className='flex items-center gap-3' key={option.value}>
          <Checkbox
            id={`${inputId}-${option.value}`}
            aria-labelledby={`${inputId}-${option.value}-label`}
            checked={value?.includes(option.value) ?? false}
            onCheckedChange={handleChange(option.value)}
          />
          <Label
            id={`${inputId}-${option.value}-label`}
            htmlFor={`${inputId}-${option.value}`}
            className='font-normal'
          >
            {option.label}
          </Label>
        </div>
      ))}
    </InputFieldset>
  )
}
